import bongImg from '../../assets/racing-game/horse-icons/bonk.png';
import brettImg from '../../assets/racing-game/horse-icons/brett.png';
import doggImg from '../../assets/racing-game/horse-icons/dogg.png';
import flokiImg from '../../assets/racing-game/horse-icons/floki.png';
import pepeImg from '../../assets/racing-game/horse-icons/pepe.png';
import popcatImg from '../../assets/racing-game/horse-icons/popcat.png';
import shibaImg from '../../assets/racing-game/horse-icons/shiba.png';
import wifImg from '../../assets/racing-game/horse-icons/wif.png';
// import aixbtImg from '../../assets/racing-game/horse-icons/aixbt.png';
// import brettImg from '../../assets/racing-game/horse-icons/brett.png';
// import doggImg from '../../assets/racing-game/horse-icons/dogg.png';
// import lunaiImg from '../../assets/racing-game/horse-icons/lunai.png';
// import pepeImg from '../../assets/racing-game/horse-icons/pepe.png';
// import shibaImg from '../../assets/racing-game/horse-icons/shiba.png';
// import vaderImg from '../../assets/racing-game/horse-icons/vader.png';
// import virtualImg from '../../assets/racing-game/horse-icons/virtual.png';
import aiImg from '../../assets/racing-game/stables-icons/ai-icon.png';
import stableAImg from '../../assets/racing-game/stables-icons/group-A-icon.png';
import stableBImg from '../../assets/racing-game/stables-icons/group-B-icon.png';
import memeImg from '../../assets/racing-game/stables-icons/meme-icon.png';
import { ColorName } from '../../styles/colors.ts';
import { b2cVersion } from '../consts.ts';
import { HORSES, StableName } from './horses.ts';


export const ROAD_SCALE = 5;

export type Position = [number, number, number];

export type HorseName = keyof typeof HORSES;
// STABLE 1 Memes: $DOGE, $SHIB, $PEPE, $BRETT
export const normalTokensIcons: {
  [key in HorseName]: string;
} = {
  bonk: bongImg,
  floki: flokiImg,
  shib: shibaImg,
  doge: doggImg,
  pepe: pepeImg,
  brett: brettImg,
  popcat: popcatImg,
  wif: wifImg,
  // shib: shibaImg,
  // doge: doggImg,
  // pepe: pepeImg,
  // brett: brettImg,
  // virtual: virtualImg,
  // aixbt: aixbtImg,
  // vader: vaderImg,
  // lunai: lunaiImg,
};

export const gameRoundStatuses = {
  NOT_STARTED: 0,
  RACE_IN_PROGRESS: 1,
  BREAK_PERIOD: 2,
  COMPLETED: 3,
} as const;

export type GameRoundStatus =
  (typeof gameRoundStatuses)[keyof typeof gameRoundStatuses];

export const stablesData: {
  [key in StableName]: {
    icon: string;
    name: string;
    altName: string;
    color: ColorName;
  };
} =
  false && b2cVersion
    ? {
        A: {
          icon: memeImg,
          name: 'MEME COINS',
          altName: 'MEME',
          color: 'horseGroupGold',
        },
        B: {
          icon: aiImg,
          name: 'AI AGENTS',
          altName: 'AI',
          color: 'horseGroupSilver',
        },
      }
    : {
        A: {
          icon: stableAImg,
          name: 'Group A',
          altName: 'A',
          color: 'horseGroupGold',
        },
        B: {
          icon: stableBImg,
          name: 'Group B',
          altName: 'B',
          color: 'horseGroupSilver',
        },
      };

export const AGroupTokens: HorseName[] = ['doge', 'pepe', 'wif', 'brett'];
export const BGroupTokens: HorseName[] = ['shib', 'bonk', 'floki', 'popcat'];
